module.exports = __webpack_public_path__ + "static/media/phone.47ecff03.svg";